module.exports = __webpack_public_path__ + "media/luxury-2026/original-staircase-view-bd856fb0.jpg";